import React from 'react';

import {
  Row,
  Col,
  Grid,
} from '@sketchpixy/rubix';

const pjson = require('../../package.json')

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      version: 0
    };
  }

  componentDidMount() {
    this.setState({
      version: pjson.version,
    });
  }

  render() {
    var year = new Date().getFullYear();
    return (
      <div id='footer-container'>
        <Grid id='footer' className='text-center'>
          <Row>
            <Col xs={12}>
              <div>© {year} NEOFECT - v{this.state.version}</div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/footer.js